import { useCallback, useEffect, useState } from 'react';
import HardWordBanner from 'src/components/ui/GlobalComponents/HardWordBanner/HardWordBanner';
import { useChallenge } from 'src/hook/data/useChallenge';
import { useLearn } from 'src/hook/data/useLearn';
import { useAudio } from 'src/hook/global/useAudio';
import { useLearnWizard } from '../../../hook/components/useLearnWizard';
import useUser from '../../../hook/data/useUser';
import { PageSource, Voice } from '../../../model/enum/enums';
import { Word } from '../../../model/Word';
import { WordData } from '../../../model/WordData';
import ImageSection from '../../ui/GlobalComponents/ImageSection/ImageSection';
import ActionButtons from './ActionButtons/ActionButtons';
import AudioPlayButton from './AudioPlayButton/AudioPlayButton';
import styles from './MainLearn.module.scss';

interface MainLearnProps {
    word: Word;
    wordData: WordData;
}

const MainLearn = ({ word, wordData }: MainLearnProps) => {
    const { userInfo, ensureCasing } = useUser();
    const [isPlaying, setIsPlaying] = useState(false);
    const { playWord } = useAudio();
    const { autoPlay, setAutoPlay } = useLearnWizard();
    const { setAutoPlay: setAutoPlayChallenge } = useChallenge();
    const { currentCard } = useLearn();

    const handlePlayAudio = useCallback((checkAutoPronounce: boolean) => {
        playWord(word?.ID!, checkAutoPronounce);
        setAutoPlay(false);
        setAutoPlayChallenge(false);
        setTimeout(() => setIsPlaying(false), 500);
    }, [playWord, word?.ID, setAutoPlay, setAutoPlayChallenge]);


    useEffect(() => {
        if (autoPlay && word?.ID && currentCard?.wordId === word?.ID) {
            handlePlayAudio(true);
        }
    }, [autoPlay, word?.ID, handlePlayAudio, currentCard?.wordId]);

    return (
        <article className={styles.mainLearn}>
            <HardWordBanner word={word} pageSource={PageSource.Learn} />
            <div className={styles.mainContent}>
                <ImageSection word={word} />
                <AudioPlayButton
                    handlePlayAudio={handlePlayAudio}
                    isPlaying={isPlaying}
                    className={styles.playButton}
                />
            </div>
            <div className={`${styles.wordInfo} ${isPlaying ? styles.playing : ''}`}>
                <h1>{ensureCasing(word?.Text)}</h1>
                {word?.BritishPhonetic && word?.AmericanPhonetic && (
                    <p>/{userInfo?.Voice === Voice.gb ? word?.BritishPhonetic : word?.AmericanPhonetic}/</p>
                )}
            </div>
            <ActionButtons
                word={word}
                wordData={wordData}
            />
        </article>
    );
};

export default MainLearn;